<template>
  <div class="current-card-number-section">
    <h6 class="current-card-number-section__title">
      {{ $tc('PaymentPage.EditPage.currentCardNumber') }}
    </h6>
    <fieldset-confirm-parts
      class="current-card-number-section__confirm"
      :label="$tc('CreditCardPayment.inputLabel.number')"
      :value="currentCardNumber"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import FieldsetConfirmParts from '@/components/common/form/FieldsetConfirmParts.vue'

/**
 * クレジットカード情報変更 現在のカード番号 セクション
 */
export default defineComponent({
  name: 'CurrentCardNumberSection',
  components: {
    FieldsetConfirmParts,
  },
  props: {
    cardLast4Digits: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    /**
     * 現在のカード番号
     * todo: カード番号取得
     */
    const currentCardNumber = computed(() => `************${props.cardLast4Digits}`)

    return {
      currentCardNumber,
    }
  },
})
</script>

<style lang="scss" scoped>
.current-card-number-section {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 34px 16px 0;
  gap: 4px;

  &__title {
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.44;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $black20;
  }

  &__confirm {
    border-bottom: none;
  }
}
</style>
